module.exports = __webpack_public_path__ + "img/og-classic.117ed7ea.png";